<template>
  <div className="pricing-page">
    <stripe-pricing-table
      v-if="customerSessionSecret"
      :pricing-table-id="pricingTableId"
      :publishable-key="publishableKey"
      :customer-session-client-secret="customerSessionSecret"
    />
  </div>
</template>

<script>
import httpService from "@/api/http";

export default {
  name: 'PricingTable',

  data() {
    return {
      pricingTableId: process.env.VUE_APP_STRIPE_PRICING_TABLE_ID,
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      customerSessionSecret: null,
    };
  },

  async mounted() {
    await this.fetchCustomerSession();
  },

  methods: {
    async fetchCustomerSession() {
      try {
        const { data } = await httpService.post('/stripe/customer-session');
        this.customerSessionSecret = data.data.clientSecret;
        console.log(this.customerSessionSecret)
      } catch (error) {
        console.error('Failed to fetch customer session:', error);
      }
    },
  },
};
</script>
